import { useState, useEffect, memo } from "react";
import { signInWithEmailAndPassword, sendPasswordResetEmail, signOut } from 'firebase/auth';
import { ref, get } from "firebase/database";
import { auth, db } from "../../functions/api_firebase";
import { useAuth } from "../../functions/AuthContext";
import Swal from "sweetalert2";
import AnimacionCarga from "./animacion_de_carga";
import LogoLetras from "../../assets/coordi_ph_logo_letras_2.png"
import "../css/login.css";
import "../css/parametros_globales.css";

const ModalRestablecerClave = ({ onCerrar }) => {
  const [correo, setCorreo] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [error, setError] = useState("");

  const enviar = async (e) => {
    e.preventDefault();
    setError("");
    if (!correo) { setError("Ingresa tu correo electrónico."); return; }
    try {
      setEnviando(true);
      await sendPasswordResetEmail(auth, correo.trim().toLowerCase());
      setEnviado(true);
    } catch (err) {
      if (err.code === "auth/user-not-found" || err.code === "auth/invalid-email") {
        setError("No existe una cuenta registrada con ese correo.");
      } else {
        setError("No se pudo enviar el correo. Intenta de nuevo.");
      }
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(0,0,0,0.45)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}
      onClick={onCerrar}
    >
      <div style={{
        background: "#fff", borderRadius: "14px",
        padding: "36px 32px 28px",
        width: "100%", maxWidth: "400px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        position: "relative",
        animation: "fadeInUp 0.2s ease",
      }}
        onClick={(e) => e.stopPropagation()}
      >
        <style>{`
          .modal-reset input[type=email],
          .modal-reset input[type=submit] {
            width: 100% !important;
            margin: 6px 0 !important;
            box-sizing: border-box !important;
          }
        `}</style>
        <button onClick={onCerrar} style={{
          position: "absolute", top: 14, right: 16,
          background: "none", border: "none", fontSize: "20px",
          cursor: "pointer", color: "#aaa", lineHeight: 1,
        }}>✕</button>

        {enviado ? (
          <div style={{ textAlign: "center", padding: "10px 0" }}>
            <i className="bi bi-envelope-check" style={{ fontSize: "48px", color: "#ff4747" }} />
            <h3 style={{ color: "#2c3e50", margin: "12px 0 10px", fontSize: "18px" }}>Correo enviado</h3>
            <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.6" }}>
              Enviamos un enlace de restablecimiento a<br />
              <strong style={{ color: "#333" }}>{correo}</strong>.<br />
              Revisa tu bandeja de entrada.
            </p>
            <button onClick={onCerrar} style={{
              marginTop: "20px", padding: "11px 32px",
              background: "#ff4747", color: "#fff",
              border: "none", borderRadius: "7px",
              fontWeight: "600", fontSize: "14px", cursor: "pointer",
            }}>Entendido</button>
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <i className="bi bi-shield-lock" style={{ fontSize: "36px", color: "#ff4747" }} />
              <h3 style={{ color: "#2c3e50", margin: "8px 0 0", fontSize: "18px", fontWeight: "700" }}>Restablecer contraseña</h3>
              <p style={{ color: "#888", fontSize: "13px", marginTop: "6px" }}>
                Ingresa tu correo y te enviaremos un enlace para crear una nueva contraseña.
              </p>
            </div>

            <form onSubmit={enviar} className="modal-reset">
              <input
                type="email"
                placeholder="tu@correo.com"
                value={correo}
                onChange={(e) => { setCorreo(e.target.value); setError(""); }}
                style={{ border: error ? "1px solid #ff4747" : "" }}
              />
              {error && (
                <p style={{ color: "#ff4747", fontSize: "12px", margin: "-2px 12px 8px", textAlign: "left" }}>{error}</p>
              )}
              <input
                type="submit"
                value={enviando ? "Enviando..." : "Enviar enlace"}
                disabled={enviando}
                style={{ opacity: enviando ? 0.6 : 1, cursor: enviando ? "not-allowed" : "pointer", width: "102%" }}
              />
            </form>

            <p style={{ textAlign: "center", marginTop: "16px", fontSize: "13px", color: "#aaa" }}>
              ¿Recordaste tu clave?{" "}
              <button onClick={onCerrar} style={{
                background: "none", border: "none", color: "#ff4747",
                fontWeight: "600", fontSize: "13px", cursor: "pointer", padding: 0,
              }}>Volver</button>
            </p>
          </>
        )}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

const InicioDeSesion = memo(() => {

  const renderLineBreaks = (count) => Array.from({ length: count }, (_, index) => <br key={index} />);
  const [credenciales, setCredenciales] = useState({ correo: "", clave: "" });
  const [estadoCarga, setEstadoCarga] = useState(true);
  const [mostrarModalClave, setMostrarModalClave] = useState(false);
  const [mostrarClave, setMostrarClave] = useState(false);
  const { usuario, cargando } = useAuth();

  useEffect(() => {
    if (!cargando && usuario) {
      window.location.replace("/inicio");
    }
  }, [usuario, cargando]);

  const mostrarAlerta = (title, text, icon) => {
    Swal.fire({ title, text, icon, confirmButtonText: "Confirmar" });
  };

  const validarEstado = async (data) => {
    const { estadoregistro } = data;

    if (estadoregistro === "AUTORIZADO") {
      return;
    }

    const mensajes = {
      PENDIENTE: {
        titulo: "Su cuenta no se encuentra aprobada.",
        texto: "Su usuario aún no se encuentra autorizado por la administración.",
      },
      "SIN CONFIRMAR CORREO": {
        titulo: "Su cuenta no se encuentra aprobada.",
        texto: "Su usuario aún no se encuentra autorizado por la administración.",
      },
      RECHAZADO: {
        titulo: "Su cuenta fue rechazada.",
        texto: "Su cuenta fue rechazada, en caso tal de ser un error, comunicarse con el administrador de la unidad residencial.",
      },
      ELIMINADO: {
        titulo: "Cuenta eliminada.",
        texto: "Su cuenta fue eliminada de la plataforma, en caso de requerir una reactivación, se debe comunicar con la administración.",
      },
    };

    const mensaje = mensajes[estadoregistro] || {
      titulo: "Error en la cuenta.",
      texto: "No existe un estado asignado a este perfil, hay un error en la base de datos.",
    };

    await signOut(auth);
    localStorage.clear();
    mostrarAlerta(mensaje.titulo, mensaje.texto, "error");
  };

  const iniciarSesion = async (e) => {
    e.preventDefault();

    if (credenciales.correo === "" || credenciales.clave === "") {
      mostrarAlerta("Faltan campos por rellenar.", "Debe diligenciar todos los campos para poder iniciar sesión en la plataforma.", "error");
      return;
    }

    try {
      setEstadoCarga(false);
      await signInWithEmailAndPassword(auth, credenciales.correo, credenciales.clave);

      const usuarioRuta = credenciales.correo.toString().replaceAll("@", "").replaceAll(".", "");
      const userIdSnapshot = await get(ref(db, `/correos/${usuarioRuta}`));
      const userId = userIdSnapshot.val();

      if (!userId) {
        mostrarAlerta("Usuario no encontrado", "No existe información asociada a este correo.", "error");
        setEstadoCarga(true);
        return;
      }
      const userDataSnapshot = await get(ref(db, `/usuarios/${usuarioRuta}/${userId}`));
      const userData = userDataSnapshot.val();

      if (!userData) {
        mostrarAlerta("Datos del usuario no encontrados", "No se pudieron cargar los datos del perfil.", "error");
        setEstadoCarga(true);
        return;
      }

      await validarEstado(userData);
      setEstadoCarga(true);

    } catch (error) {
      switch (error.message) {
        case "Firebase: Error (auth/invalid-credential).":
          mostrarAlerta("Credenciales incorrectas.", "Inténtalo de nuevo.", "error");
          break;
        case "Firebase: Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later. (auth/too-many-requests).":
          mostrarAlerta("La cuenta se ha bloqueado temporalmente.", "Se realizaron muchos intentos de sesión, inténtelo más tarde.", "warning");
          break;
        default:
          mostrarAlerta("Error desconocido", error.message, "error");
          break;
      }
      setEstadoCarga(true);
    }
  };

  return (
    <div>
      {mostrarModalClave && <ModalRestablecerClave onCerrar={() => setMostrarModalClave(false)} />}

      {/* Mientras Firebase revisa la sesión no se muestra el formulario:
          si ya hay sesión abierta, se pasa directo al inicio sin ver el login. */}
      {estadoCarga && !cargando && !usuario ? (
        <div className="InicioSesion">

          {renderLineBreaks(10)}

          <img alt="CoordiPH" src={LogoLetras} />

          <br /><br />

          <form onSubmit={iniciarSesion}>
            <input
              type="email"
              placeholder="Correo electrónico"
              value={credenciales.correo}
              onChange={(e) => setCredenciales({ ...credenciales, correo: e.target.value })}
            />

            <div className="campo-clave">
              <input
                type={mostrarClave ? "text" : "password"}
                placeholder="Clave"
                autoComplete="current-password"
                value={credenciales.clave}
                onChange={(e) => setCredenciales({ ...credenciales, clave: e.target.value })}
              />
              <button
                type="button"
                className="ver-clave-login"
                onClick={() => setMostrarClave(!mostrarClave)}
                title={mostrarClave ? "Ocultar contraseña" : "Mostrar contraseña"}
                aria-label={mostrarClave ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                <i className={mostrarClave ? "bi bi-eye-slash" : "bi bi-eye"} />
              </button>
            </div>

            <input
              type="submit"
              value="INICIAR SESIÓN"
              onClick={iniciarSesion}
            />
          </form>

          <p style={{ textAlign: "center", margin: "16px 0 12px", fontSize: "13px" }}>
            <button
              type="button"
              onClick={() => setMostrarModalClave(true)}
              style={{ background: "none", border: "none", color: "#ff4747", cursor: "pointer", fontSize: "13px", fontWeight: "600", padding: 0 }}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </p>

          <p style={{ textAlign: "center", margin: "12px 0 12px", fontSize: "13px", color: "#555" }}>
            ¿No tienes cuenta?{" "}
            <a href="/registro" style={{ color: "#ff4747", textDecoration: "none", fontWeight: "600" }}>
              Regístrate aquí
            </a>
          </p>

          <p style={{ textAlign: "center", margin: "12px 0 40px", fontSize: "12px", color: "#aaa" }}>
            Al usar la plataforma aceptas nuestros{" "}
            <a href="/legal" style={{ color: "#ff4747", textDecoration: "none", fontWeight: "600" }}>
              Términos y Política de Privacidad
            </a>
          </p>
        </div>
      ) : (
        <AnimacionCarga />
      )}
    </div>
  );
});

export default InicioDeSesion;
